import { Cookies, UTM } from '~/assets/util/helpers'

export default function ({ route, store }) {
	const lang = route.query.lang || Cookies.get('user_lang')

	if (lang) {
		store.dispatch('user/setLanguage', lang)
	}

	store.dispatch('user/checkCurrentLanguage')

	// Storing UTM data
	const data = UTM.getUTMParams(route.query)

	if (UTM.isValidUTMObject(data)) {
		store.commit('user/setUTM', data)
	} else {
		store.commit('user/setUTM', UTM.getUTMCookie())
	}

	// Detection & Storing user location
	const origin = route.query.g || Cookies.get('user_origin')

	if (origin) {
		store.commit('user/setLocation', { code: origin, region: route.query.r })
	} else if (store.getters['user/origin'] === 'xx') {
		return store.dispatch('user/fetchLocation')
	}
}
